<template>
	<!-- NOTE 展开 收起 两套颜色 -->
	<div class="tag-item" :class="{ selected: curActiveChildCath == catPath }">
		{{ tabName }}
	</div>
</template>

<script>
export default {
	name: "tagItem",
	props: {
		curActiveChildCath: {
			type: String,
			default: "",
		},
		catPath: {
			type: String,
			default: "",
		},
		selected: {
			type: Boolean,
			default: false,
		},
		tabName: {
			type: String,
			default: "",
		},
	},
};
</script>

<style scoped lang="less">
.tag-item {
	height: 52px;
	width: auto;
	display: inline-flex;
	align-items: center;
	padding-left: 28px;
	padding-right: 28px;
	cursor: pointer;
	user-select: none;
	border-radius: 28px;
	background: #fff;
	background: #f6f6f6;
	&.selected {
		color: #fff;
		background: #debe8d;
	}
}
</style>
